<template>
  <v-dialog
    v-model="innerValue"
    :max-width="maxWidth"
    scrollable
    :content-class="isSelfServe ? 'ma-2' : 'ma-2 rounded-lg'"
    :persistent="persistent"
    :no-click-animation="noClickAnimation"
    @click:outside="$emit('click:outside')"
  >
    <v-card :class="[windowClass]">
      <div class="d-flex mb-4" :class="[headerClass]" v-if="header">
        <v-icon
          :color="headerIconColor"
          v-if="headerIcon"
          class="d-none d-md-flex"
        >
          {{ headerIcon }} mdi-36px</v-icon
        >
        <h2 class="dialog-title ml-md-2">
          {{ title || titleLocal }}
        </h2>
        <v-spacer></v-spacer>
        <v-btn
          aria-label="Close"
          icon
          class="btn-close font-weight-bold"
          @click="cancel"
        >
          <template v-if="$slots.closeIcon">
            <slot name="closeIcon"></slot>
          </template>
          <template v-else>
            <img
              v-if="dark2Icon"
              class="logo"
              src="@/assets/icons/dark2_close_icon.svg"
              alt="close_icon"
            />
            <v-icon v-else> mdi-close </v-icon>
          </template>
        </v-btn>
      </div>
      <v-divider v-if="headerDivider"></v-divider>

      <v-card-text
        :class="[isSelfServe ? 'mb-5' : 'mb-10', contentClass]"
        id="base-dialog"
        ref="dialogContent"
      >
        <slot name="content" :isShow="innerValue" :data="data"></slot>
        <slot />
      </v-card-text>

      <v-card-actions class="mt-6" v-if="options.hasActionBtn">
        <v-spacer></v-spacer>

        <BaseButton
          id="CancelBtn"
          className="btn-normal btn-small"
          :text="disagreeBtnText"
          @click="cancel"
        />

        <BaseButton
          id="AgreeBtn"
          className="btn-primary btn-small"
          :text="agreeBtnText"
          @click="agree"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton";

export default {
  name: "BaseDialog",
  components: {
    BaseButton,
  },
  props: {
    windowClass: String,
    headerClass: String,
    maxWidth: {
      type: Number,
      default: 800,
    },
    headerIcon: String,
    headerIconColor: String,
    header: {
      type: Boolean,
      default: true,
    },
    headerDivider: Boolean,
    contentClass: String,
    persistent: {
      type: Boolean,
      default: false,
    },
    noClickAnimation: {
      type: Boolean,
      default: false,
    },
    dark2Icon: {
      type: Boolean,
      default: false,
    },
    isSelfServe: {
      type: Boolean,
      default: false,
    },
    value: null,
    title: String,
  },
  data() {
    return {
      innerValue: false,
      options: {
        agreeBtnText: "Agree",
        disagreeBtnText: "Disagree",
        hasActionBtn: false,
      },
      resolve: () => {},
      reject: () => {},
      data: null,
      titleLocal: "",
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(value) {
      this.$emit("input", value);
    },
    // Handles external model changes.
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val;
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    open(title, data) {
      this.innerValue = true;
      this.titleLocal = title;
      this.data = data;
      setTimeout(() => {
        this.$refs.dialogContent.scrollTo(0, 0);
      }, 50);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.innerValue = false;
    },
    cancel() {
      this.$emit("dialogCloseButton", false);
      this.innerValue = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.d2c-save-exit-header {
  margin: 16px 16px 3px 16px !important;
}

.d2c-dialog-header {
  .dialog-title {
    color: #272727;
    font-size: 28px;
  }
}

.d2c-breakdown-content {
  margin-bottom: 29px !important;
}

.v-dialog {
  * {
    color: $black;
  }

  .v-card {
    border-radius: 20px !important;
    padding: 40px 20px 0px 40px;

    &.confirm-dialog {
      padding: 28px 37px;
      border-radius: 20px;
      margin-right: auto;
      margin-left: auto;
    }

    .v-card__text {
      padding: 0;
      color: rgb(0 0 0);
    }
  }

  .btn-close {
    font-size: 30px;
    color: $black-2;

    .mdi-close {
      font-size: 32px;
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .v-dialog {
    .v-card {
      padding: 32px 10px 0px 10px;

      &.confirm-dialog {
        border-radius: 10px;
        padding: 16px 24px 24px;
      }

      .v-card__text {
        padding: 0;
        color: rgb(0 0 0);
      }
    }
  }
}

#base-dialog::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgb(255 255 255 / 0%);
  border-radius: 10px;
  background-color: #ebebeb;
}

#base-dialog::-webkit-scrollbar {
  width: 10px;
  background-color: #ebebeb;
}

#base-dialog::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(255 250 250 / 30%);
  background-color: #aaa;
}

#base-dialog {
  max-height: 800px;
}
</style>
